import type { Moment } from 'moment'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import classnames from 'classnames'
import { Grid, SingleDatePickerController, useDatePickerStyles } from '@paintscout/ui'
import type { CalendarEvent } from 'paintscout'

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  paper: {
    boxShadow: 'none !important'
  },
  events: {
    borderTop: `1px solid ${theme.paintscout.palette.brand.Neutral.P90}`
  }
}))

interface CalendarMonthViewProps {
  events: CalendarEvent[]
  date: Date
  setDate: (date: Date) => void
  TableComponent: React.ComponentType<{ events: CalendarEvent[] }>
}

export default function CalendarMonthView({ events, date, setDate, TableComponent }: CalendarMonthViewProps) {
  const [tableHeight, setTableHeight] = useState(0)

  useEffect(() => {
    recalculateTableHeight()
  }, [date])

  const recalculateTableHeight = () => {
    const elements = document.getElementsByClassName('CalendarMonthGrid_month__horizontal')
    if (elements.length > 0) {
      const height = (elements[0] as any).offsetHeight
      setTableHeight(height)
    }
  }

  const classes = useStyles()
  const datePickerClasses = useDatePickerStyles({ isSingle: true, tableHeight })

  const getEventsForDay = (day: Moment) => {
    return events.filter((event) => {
      const eventStart = moment(event.start)
      const eventEnd = moment(event.end)

      return eventStart.isSameOrBefore(day, 'day') && eventEnd.isSameOrAfter(day, 'day')
    })
  }

  const handleChange = (date: Moment) => {
    setDate(date.toDate())
  }

  const dayEvents = getEventsForDay(moment(date))

  return (
    <Grid container className={classes.root} justifyContent="center" alignItems="center">
      <Grid item className={classnames(datePickerClasses.popper, classes.paper)}>
        <SingleDatePickerController
          date={moment(date)}
          onChange={handleChange}
          getEventsForDay={getEventsForDay}
          recalculateTableHeight={recalculateTableHeight}
        />
      </Grid>
      <Grid item xs={12}>
        <TableComponent events={dayEvents} />
      </Grid>
    </Grid>
  )
}
